module.exports = __webpack_public_path__ + "4167d12ffbf0efda849af90f2cb6a44a.svg";